<div class="card-header" *ngIf="article">
  {{article.header | translatedb}}
</div>
<div class="team-info-container" *ngIf="article">
  <div class="team-info-text" [innerHTML]="article.content | translatedb"></div>
</div>
